// src/stores/dailyVisits.js

import { ref, computed } from "vue";
import { defineStore } from "pinia";
import moment from "jalali-moment";

// Import other stores to use their data
import { useReceptionsStore } from "./receptions.js";
// import { useDoctorsStore } from "./doctors.js";

export const useDailyVisitsStore = defineStore("dailyVisits", () => {
  // --- State ---
  // The filter values now live in the store
  const selectedDate = ref(moment().format("jYYYY/jMM/jDD"));
  const selectedDoctor = ref(null); // Changed name for clarity

  // --- Getters ---
  // Getters are like computed properties for your store
  const filteredReceptions = computed(() => {
    // Access other stores inside the getter
    const receptionsStore = useReceptionsStore();

    let result = receptionsStore.receptionsList;

    // 1. Filter by Date using the store's state
    if (selectedDate.value) {
      result = result.filter((r) => r.receptionDate === selectedDate.value);
    }

    // 2. Filter by Doctor using the store's state
    if (selectedDoctor.value) {
      const doctorFullName = `${selectedDoctor.value.firstName} ${selectedDoctor.value.lastName}`;
      result = result.filter((r) => r.doctorName === doctorFullName);
    }

    return result;
  });

  // --- Actions ---
  // Functions to change the filter state
  function setDoctorFilter(doctor) {
    selectedDoctor.value = doctor;
  }

  function clearDoctorFilter() {
    selectedDoctor.value = null;
  }

  return {
    selectedDate,
    selectedDoctor,
    filteredReceptions,
    setDoctorFilter,
    clearDoctorFilter,
  };
});
